import { render, staticRenderFns } from "./ModalPreOrder.vue?vue&type=template&id=37a1052e&"
import script from "./ModalPreOrder.vue?vue&type=script&lang=js&"
export * from "./ModalPreOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports